<div class="mdc-layout-grid mw-100 no-offset-x-force">
  <div class="mdc-layout-grid__inner">
    @for ( contact_person of displayedContactPersons; track identifyContactPerson(contactPersonIndex, contact_person);
    let contactPersonIndex = $index) {
    <div
      class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-6-tablet mdc-layout-grid__cell--span-4-phone">
      <planone-contact-person
        [contact]="contact_person"
        [contactLink]="contactBaseLink + contact_person.id"
        [contactClickable]="contactClickable"
        [fairId]="fairId"
        [exhibitorId]="exhibitorId"
        [exhibitorName]="exhibitorName"
        [index]="contactPersonIndex + 1"
        [size]="size"
        (trackContactClick)="trackContactClick.emit($event)"></planone-contact-person>
    </div>
    } @if (expandable) {
    <div
      class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12-desktop mdc-layout-grid__cell--span-12-tablet mdc-layout-grid__cell--span-4-phone expand-list">
      @if (!expanded) {
      <a (click)="showMore()" i18n="@@featureProductDetails-contactPersons-more">
        + Alle anzeigen ({{ contactPersons?.length ?? '0' }})
      </a>
      } @if (expanded) {
      <a (click)="showLess()" i18n="@@featureProductDetails-contactPersons-less">- Weniger anzeigen</a>
      }
    </div>
    }
  </div>
</div>
